import { useEffect } from "react";

const EmptyInviteRedirect = () => {
  useEffect(() => {
    window.location.href = "https://keyflow.com/app";
  }, []);
};

export default EmptyInviteRedirect;
